import createQueryDuck from '@/redux/query';

import serializer from '../serializer';
import { getQuery } from '../utils';

export default createQueryDuck('campaign_aggregation', {
  getRoot: getQuery,
  serializer,
});
